// One-way Android -> page ingress. No Android methods are exposed to web content.
export function bindNativeScanner(handler) {
  const receive = packet => handler(packet);
  window.masiviGudangScanner = receive;
  return () => { if (window.masiviGudangScanner === receive) delete window.masiviGudangScanner; };
}

export function validNativeScan(packet) {
  return packet?.action === 'scan' && typeof packet.scope === 'string' && packet.scope.length <= 1000 &&
    typeof packet.id === 'string' && /^[a-zA-Z0-9-]{16,80}$/.test(packet.id) &&
    typeof packet.code === 'string' && packet.code.trim().length > 0 && packet.code.length <= 100 &&
    !/[\u0000-\u001f\u007f]/.test(packet.code);
}
